import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { Box, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

export default function SwipeableNotification({ 
  children, 
  onDismiss, 
  showCloseButton = true 
}) {
  const [offset, setOffset] = useState(0);
  const [swiping, setSwiping] = useState(false);

  const handlers = useSwipeable({
    onSwiping: (eventData) => {
      setSwiping(true);
      setOffset(eventData.deltaX);
    },
    onSwipedLeft: () => {
      if (Math.abs(offset) > 100) {
        handleDismiss();
      } else {
        resetPosition();
      }
    },
    onSwipedRight: () => {
      if (Math.abs(offset) > 100) {
        handleDismiss();
      } else {
        resetPosition();
      }
    },
    trackMouse: true, // Enable mouse drag on desktop
    preventScrollOnSwipe: true
  });

  const handleDismiss = () => {
    setOffset(offset > 0 ? 500 : -500); // Animate out
    setTimeout(() => {
      onDismiss();
    }, 200);
  };

  const resetPosition = () => {
    setSwiping(false);
    setOffset(0);
  };

  return (
    <Box
      {...handlers}
      sx={{
        position: 'relative',
        transform: `translateX(${offset}px)`,
        transition: swiping ? 'none' : 'transform 0.2s ease-out',
        opacity: Math.max(0, 1 - Math.abs(offset) / 200),
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing'
        }
      }}
    >
      {children}
      
      {showCloseButton && (
        <IconButton
          onClick={handleDismiss}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            bgcolor: 'rgba(0,0,0,0.3)',
            '&:hover': {
              bgcolor: 'rgba(0,0,0,0.5)'
            }
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
}
